var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0542 8.1706L13.7042 2.5106C13.7979 2.41763 13.8723 2.30703 13.9231 2.18517C13.9739 2.06331 14 1.93261 14 1.8006C14 1.66859 13.9739 1.53788 13.9231 1.41602C13.8723 1.29416 13.7979 1.18356 13.7042 1.0906C13.5168 0.904346 13.2634 0.799805 12.9992 0.799805C12.735 0.799805 12.4816 0.904346 12.2942 1.0906L7.2942 6.0406L2.3442 1.0906C2.15684 0.904346 1.90339 0.799804 1.6392 0.799804C1.37502 0.799804 1.12156 0.904346 0.934202 1.0906C0.839714 1.18321 0.764544 1.29366 0.713047 1.41553C0.66155 1.53741 0.634752 1.66829 0.634203 1.8006C0.634752 1.9329 0.66155 2.06379 0.713047 2.18566C0.764543 2.30754 0.839714 2.41798 0.934202 2.5106L6.5842 8.1706C6.67784 8.2721 6.79149 8.35311 6.91799 8.40852C7.04449 8.46393 7.1811 8.49253 7.3192 8.49253C7.4573 8.49253 7.59391 8.46393 7.72041 8.40852C7.84691 8.35311 7.96056 8.2721 8.0542 8.1706Z",
    fill: "#A7B1BE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/SelectIcon.06a5a83aeb51ceae17f95fc7bf5f7cc9.svg";
export { ForwardRef as ReactComponent };